import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.75 9.75V9H4V9.75H4.75ZM19.25 9.75H20V9H19.25V9.75ZM19.25 21.25V22H20V21.25H19.25ZM4.75 21.25H4V22H4.75V21.25ZM15.5 9.75C15.5 10.1642 15.8358 10.5 16.25 10.5C16.6642 10.5 17 10.1642 17 9.75H16.25H15.5ZM7 9.75C7 10.1642 7.33579 10.5 7.75 10.5C8.16421 10.5 8.5 10.1642 8.5 9.75H7.75H7ZM12.75 14V13.25H11.25V14H12H12.75ZM11.25 17V17.75H12.75V17H12H11.25ZM4.75 9.75V10.5H19.25V9.75V9H4.75V9.75ZM19.25 9.75H18.5V21.25H19.25H20V9.75H19.25ZM19.25 21.25V20.5H4.75V21.25V22H19.25V21.25ZM4.75 21.25H5.5V9.75H4.75H4V21.25H4.75ZM16.25 7H15.5V9.75H16.25H17V7H16.25ZM7.75 9.75H8.5V7H7.75H7V9.75H7.75ZM12 2.75V3.5C13.933 3.5 15.5 5.067 15.5 7H16.25H17C17 4.23858 14.7614 2 12 2V2.75ZM12 2.75V2C9.23858 2 7 4.23858 7 7H7.75H8.5C8.5 5.067 10.067 3.5 12 3.5V2.75ZM12 14H11.25V17H12H12.75V14H12Z",
		fill: "currentcolor"
	})]
});
export default SvgLock;
